const accountTableActionKeys = [
    'mainAction',
    'secondaryAction',
    'localActions',
    'globalActions',
];
/**
 * to avoid interference with a specific global account table config actions
 *
 * e.g. set via global <ContactManagementConfigProvider>
 */
export function removeAccountTableGlobalConfigActions(dataTableProps) {
    accountTableActionKeys.forEach((key) => {
        if (key in dataTableProps) {
            delete dataTableProps[key];
        }
    });
    return dataTableProps;
}
